var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-form-radio-group',{attrs:{"id":_vm.id,"checked":_vm.value,"options":_vm.$options.agentTypes,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }